var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('filter-summary',_vm._g({attrs:{"icon":"customers","title":"顧客グループ","scroll-to-id":_vm.scrollToId}},_vm.$listeners),[_vm._v(_vm._s(_vm.filename))])}
var staticRenderFns = []

export { render, staticRenderFns }